export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-wrench-f12f754cd18d4137ac8398488321bf0c.svg";